import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../theme/useTheme';
import { Button } from '../components/button';

/**
 * Light/dark toggle. `label` is passed by the host (translated) so the control has an accessible
 * name without this package hardcoding a string.
 */
export function ModeToggle({ label }: { label: string }): React.ReactElement {
  const { resolvedMode, toggleMode } = useTheme();
  return (
    <Button variant="ghost" size="icon" aria-label={label} onClick={toggleMode}>
      {resolvedMode === 'dark' ? <Moon /> : <Sun />}
    </Button>
  );
}
